import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";

async function masters(): Promise<CommonRequest<any>> {
  const response = await http.getData("/asesmen-pra-bedah/masters").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function create(data: any): Promise<CommonRequest<any>> {
  const response = await http.postData("/asesmen-pra-bedah", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function update(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-pra-bedah/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(
  registerId: string | number
): Promise<CommonRequest<any[]>> {
  const response = await http
    .getData(`/register/${registerId}/asesmen-pra-bedah`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/asesmen-pra-bedah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signDpjp(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-pra-bedah/${id}/sign-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function markPasien(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/asesmen-pra-bedah/${id}/mark-pasien`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http
    .deleteData(`/asesmen-pra-bedah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function print(id: number) {
  window.open(`${http.getAPI()}/asesmen-pra-bedah/${id}/pdf`, "_blank");
}

export default {
  masters,
  create,
  update,
  getByRegister,
  find,
  signDpjp,
  markPasien,
  destroy,
  print
};
